import DashedLine from 'assets/images/directDeposit/DashedLine.svg';
import PinwheelMark from 'assets/images/directDeposit/PinwheelMark.svg';
import VaroLogo from 'assets/images/vxl/logos/varo-logo-purple.svg';
import { usePathname } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import Animated from 'react-native-reanimated';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import vxlColors from 'shared/styles/color/core';
import theme from 'shared/styles/theme';

const DirectDepositInstantSwitchIntroScreen = () => {
  const { t: translatedText } = useTranslation('directDeposit');
  const path = usePathname();
  const customAttributes = {
    screen_name: 'Direct Deposit Instant Switch Intro',
    screen_url: path,
  };

  useViewDidFocusScreenAnalyticsEvent({
    key: 'dd-instant-switch-intro',
    customAttributes,
  });

  useViewDidFocusScreenAnalyticsEvent({
    key: '/move-money/direct-deposit/instant-switch-intro',
    customAttributes,
  });

  return (
    <Animated.View
      style={styles.overlayContainer}
      accessible
      accessibilityLabel="varo-intro-loading"
      // accessibilityRole="progressbar"
    >
      <View style={styles.logoContainer}>
        <VaroLogo id="varo-logo-purple" />
        <View style={styles.dashedLine} accessibilityLabel="Dashed Line">
          <DashedLine />
        </View>
        <View style={styles.pinwheelMark} accessibilityLabel="Pinwheel Mark">
          <PinwheelMark />
        </View>
      </View>
      <View style={styles.textContainer}>
        <TitleLgText style={styles.centeredContainer}>
          {translatedText('LoaderScreenTitle')}
        </TitleLgText>
        <BodyBaseText style={styles.bodyContainer}>
          {translatedText('LoaderScreenBody')}
        </BodyBaseText>
        <View style={styles.securityContainer}>
          <View style={styles.buttonWrapper}>
            <Icon
              iconColor={theme.color.text.secondary}
              iconKey="LOCK"
              iconAccessibilityLabel="LOCK"
            />
          </View>
          <BodyBaseText style={styles.subText}>
            {translatedText('LoaderScreenLockSubtext')}
          </BodyBaseText>
        </View>

        <View style={[styles.securityContainer, styles.securityFeatureSpacing]}>
          <View style={styles.buttonWrapper}>
            <Icon
              iconColor={theme.color.text.secondary}
              iconKey="SPARKLE"
              iconAccessibilityLabel="SPARKLE"
            />
          </View>
          <BodyBaseText style={styles.subText}>
            {translatedText('LoaderScreenSparkleSubtext')}
          </BodyBaseText>
        </View>
      </View>
      <LoadingSpinner fill={vxlColors.core.neutrals.black} />
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  bodyContainer: {
    marginBottom: theme.spacing.xxl,
    textAlign: 'center',
  },
  buttonWrapper: {
    width: 24,
    height: 24,
    marginRight: theme.spacing.xs,
  },
  centeredContainer: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: theme.spacing.s,
  },
  dashedLine: { marginHorizontal: 14 },
  logoContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing.xs,
    marginBottom: theme.spacing.xxl,
    borderRadius: 10,
  },
  overlayContainer: {
    alignItems: 'center',
    backgroundColor: theme.color.background.primary,
    height: '100%',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 2,
  },
  pinwheelMark: {
    height: 48,
    width: 48,
    padding: 12,
    borderWidth: 1,
    borderColor: theme.color.border.primary,
    borderRadius: 10,
  },
  securityContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  securityFeatureSpacing: {
    marginTop: 12,
  },
  subText: {
    color: theme.color.text.secondary,
  },
  textContainer: {
    paddingHorizontal: theme.spacing.l,
    marginBottom: theme.spacing.xxl,
  },
});

export default DirectDepositInstantSwitchIntroScreen;
